/**
 * Checks whether a country code is in the eSIM excluded list
 * provided by the program-configuration API.
 */
export function isEsimExcludedCountry(countryCode: string, excludedCountryCodes: Array<string>): boolean {
  return excludedCountryCodes.includes(countryCode.toUpperCase())
}
